import React from 'react'
import dynamic from 'next/dynamic'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Grid, GridItem, Heading, useBreakpointValue } from '@chakra-ui/react'
import { Offer, AutoPromo, ActionBar } from 'src/components/NltOffers/'
import { useTranslation } from 'react-i18next'
import { setListingPage } from 'src/redux/nlt-offer'
import { useBackButton } from 'src/utils/hooks'
import { LinkRel } from 'src/components/common'
import { OfferList } from 'src/components/common/StructuredData'

const Pagination = dynamic(() => import('src/components/Paginator/Pagination'))
const MobileActionBar = dynamic(() => import('src/components/NltOffers/MobileActionBar'))
const HomeOffersList = dynamic(() => import('src/components/NltOffers/HomeOffersList'))

const LandingBrandNltOffersContainer = ({ slug, page }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useBreakpointValue({ base: true, md: false })
  const filterMenuIsOpen = useSelector((state: Store.RootState) => state.nlt.filterMenuIsOpen)
  const offers = useSelector((state: Store.RootState) => state.nlt.filteredOffers)
  const otherOffers = useSelector((state: Store.RootState) => state.nlt.offers)

  const onPaginatorClickHandler = page => dispatch(setListingPage(page))

  useBackButton()

  return <Box px="l">
    <LinkRel
      rel="canonical"
      href={`https://www.carplanner.com/noleggio-a-lungo-termine/${slug}${page && page > 1 ? `?pagina=${page}` : ''}`}
    />

    <OfferList
      items={
        offers.items.map(item => [
          'https://carplanner.com/noleggio-a-lungo-termine/',
          item.brandCode,
          '/',
          item.modelCode,
          '/',
          item.code,
          '?deposit=',
          item.deposit,
          '&contractLength=',
          item.contractLength,
          '&annualMileage=',
          item.annualMileage
        ].join(''))
      }
    />

    <ActionBar offersCount={offers.items.length} />

    {offers.items && offers.items.length ?
      <>
        <Grid
          templateColumns={{
            md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
            lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`,
          }}
          gap={6}
          pt="l"
          pb="24px"
        >
          {offers.items.map(item => {
            return item.code === 'auto-promo' ?
              (<GridItem key={`${item.code}- ${item.title} `} display="inline-grid">
                <AutoPromo item={item} />
              </GridItem>)
              :
              (<GridItem key={item.code} display="inline-grid">
                <Offer item={item} />
              </GridItem>)
          })}
          <GridItem
            colSpan={{
              md: filterMenuIsOpen ? 2 : 3,
              lg: filterMenuIsOpen ? 3 : 4
            }}
            mt="-2"
            textAlign="left"
            key="load-more"
          >
            <Pagination
              currentPage={offers.currentPage}
              perPage={offers.pageSize}
              total={offers.results}
              onClick={onPaginatorClickHandler}
            />
          </GridItem>
        </Grid>

        {isMobile &&
          <MobileActionBar />
        }
      </>
      :
      isMobile ?
        <Box pb="24px" px="l">
          <Heading as="h3" px="l" pt="l" fontSize="2xl" fontFamily="Montserrat-SemiBold">{t('nltPage:notFound')}</Heading>
          <HomeOffersList
            action={t('indexPage:nlt_offers.action')}
            alt={t('indexPage:nlt_offers.alt')}
            bgColor="baseNeutral.100"
            href="/noleggio-a-lungo-termine"
            offers={otherOffers}
            numPerView={filterMenuIsOpen ? 3 : 4}
          />
        </Box>
        :
        <Grid
          templateColumns={{
            md: `repeat(${filterMenuIsOpen ? 2 : 3}, 1fr)`,
            lg: `repeat(${filterMenuIsOpen ? 3 : 4}, 1fr)`,
          }}
          gap={6}
        >
          <GridItem colSpan={{
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          }}>
            <Heading as="h3" fontSize="2xl" fontFamily="Montserrat-SemiBold">{t('nltPage:notFound')}</Heading>
          </GridItem>
          <GridItem colSpan={{
            md: filterMenuIsOpen ? 2 : 3,
            lg: filterMenuIsOpen ? 3 : 4
          }}>
            <HomeOffersList
              w="100%"
              action={t('indexPage:nlt_offers.action')}
              alt={t('indexPage:nlt_offers.alt')}
              bgColor="baseNeutral.100"
              href="/noleggio-a-lungo-termine"
              offers={otherOffers}
              numPerView={filterMenuIsOpen ? 3 : 4}
              paddingLeft="0px"
              paddingRight="0px"
            />
          </GridItem>
        </Grid>
    }
  </Box>
}

export default LandingBrandNltOffersContainer
